import ChartTab from "./ChartTab";
import React from "react";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

class ChartBudgetCategoryTiersTabPure extends React.Component {
  render() {
    const { data } = this.props;

    const defaultPageSize = computeDefaultTableSize(data, "tiers.name");

    const columnName = this.props.customColumnName
      ? this.props.customColumnName
      : "tiers";

    let pivots = ["tiers", "family", "category", "project"];
    let showColumns = [
      columnName, 
      "family",
      "category", 
      "project", 
      "dateMonthYear",
      "previousYearRealValueOrBudget",
      "budget",
      "realValue",
      "budgetVariation",
      "budgetVariationPourcent"
    ];

    return (
      <ChartTab
        {...this.props}
        data={data}
        min
        defaultPageSize={defaultPageSize}
        pivots={pivots}
        showColumns={showColumns}
        showPagination={false}
        showDetails={false}
        showExtra={true}
        defaultSorted={[
          {
            id: "tiers",
            desc: false
          },
          {
            id: "family",
            desc: false
          },
          {
            id: "category",
            desc: false
          },
          {
            id: "project",
            desc: false
          },
          {
            id: "dateMonthYear",
            desc: false
          }
        ]}
      />
    );
  }
}

export default ChartBudgetCategoryTiersTabPure;
